import { Guideline, TermsOfMonitoring } from 'types/monitoring';
import { create } from 'zustand';

interface MonitoringStore {
	guidelines: {
		monitoring: Guideline[];
		express: Guideline[];
	};
	stepsDraft: any;
	termsOfMonitoring: TermsOfMonitoring;
	paymentMethods: any;
	initialStepData: any;

	setGuidelines: (slug: 'monitoring' | 'express', data: Guideline[]) => void;
	setStepsDraft: (stepsDraft: any) => void;
	setInitialStepData: (initialStepData: any) => void;
	setTermsOfMonitoring: (termsOfMonitoring: TermsOfMonitoring) => void;
	setPaymentMethods: (paymentMethods: any) => void;
	clearStore: () => void;
}

export const useMonitoringStore = create<MonitoringStore>((set) => {
	const initialState = {
		guidelines: {
			monitoring: [],
			express: [],
		},
		stepsDraft: {},
		initialStepData: {},
		termsOfMonitoring: {
			price: '',
			duration: '',
			phases: '',
		},
		paymentMethods: [],
	};

	return {
		...initialState,
		setGuidelines: (slug, data) =>
			set((state) => ({
				guidelines: { ...state.guidelines, [slug]: data },
			})),
		setStepsDraft: (stepsDraft) => set({ stepsDraft }),
		setTermsOfMonitoring: (termsOfMonitoring) => set({ termsOfMonitoring }),
		setPaymentMethods: (paymentMethods) => set({ paymentMethods }),
		setInitialStepData: (initialStepData) => set({ initialStepData }),
		clearStore: () => set(() => initialState),
	};
});
